import styled from 'styled-components';
import { FileOutlined } from '@ant-design/icons';

export const ListContainer = styled.div`
  .ant-list-item {
    padding: 12px;
    &:hover {
      background-color: #fafafa;
    }
  }
`;

export const FileIcon = styled(FileOutlined)`
  font-size: 24px;
  margin-right: 12px;
`;




